module.exports = __webpack_public_path__ + "71d46fc1523ff5a7ad2d919f77e9dcf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/news/isaac.jpg
// module id = 315
// module chunks = 0